<form class="f-col blank-form" [formGroup]="EmergencyContactForm">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managetraveler.emercontactdetails']}} <div class="dot">.</div> <span
                class="optional">{{content?.['b2b.managetraveler.optional']}}</span>
        </h2>
        <a tabindex="0" role="button" class="link" (click)="Editpersonal()"
            *ngIf="hasEmployeeData && Loader.isEditableClicked"><mat-icon fontSet="material-symbols-outlined"
                class="edit-icon">edit</mat-icon> {{content?.['b2b.managetraveler.edit']}}</a>
    </div>
    <div class="section-content" [class.view-disabled]="(hasEmployeeData && Loader.isEditableClicked)">
        <div class="inner-contentsection">
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.contactname']}}</mat-label>
                        <input matInput formControlName="contactName"
                            (keypress)="_CommonService.allowOnlyCharacters($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)"
                            data-dd-privacy="mask">
                        <mat-error
                            *ngIf="EmergencyContactForm.get('contactName')?.hasError('required') && EmergencyContactForm.get('contactName')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.contactnamereq']}}</mat-error>
                        <mat-error
                            *ngIf="EmergencyContactForm.get('contactName')?.hasError('minlength') && EmergencyContactForm.get('contactName')?.touched">{{content?.dictionary?.['b2b.managetraveler.contactnameminlimit']}}</mat-error>
                        <mat-error
                            *ngIf="EmergencyContactForm.get('contactName')?.hasError('maxlength') && EmergencyContactForm.get('contactName')?.touched">{{content?.dictionary?.['b2b.managetraveler.contactnamemaxlimit']}}</mat-error>

                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.relationwithuser']}}</mat-label>
                        <input matInput formControlName="relationWithUser"
                            (keypress)="_CommonService.blockInvalidCharacters1($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)"
                            data-dd-privacy="mask">
                        <mat-error
                            *ngIf="EmergencyContactForm.get('relationWithUser')?.hasError('required') && EmergencyContactForm.get('relationWithUser')?.touched">{{content?.dictionary?.['b2b.managetraveler.rwureq']}}</mat-error>
                        <mat-error *ngIf="EmergencyContactForm.get('relationWithUser')?.hasError('pattern')"> {{content?.dictionary?.['b2b.managepolicy.alphabeticchar'] || 'Only alphabetic characters are allowed'}}</mat-error>
                        <mat-error
                            *ngIf="EmergencyContactForm.get('relationWithUser')?.hasError('minlength') && EmergencyContactForm.get('relationWithUser')?.touched">{{content?.dictionary?.['b2b.managetraveler.rwuminlimit']}}</mat-error>
                        <mat-error
                            *ngIf="EmergencyContactForm.get('relationWithUser')?.hasError('maxlength') && EmergencyContactForm.get('relationWithUser')?.touched">{{content?.dictionary?.['b2b.managetraveler.rwumaxlimit']}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <ng-select [items]="newCustomCountries" groupBy="group"
                        [searchFn]="_CommonService.customCountrySearchFn" formControlName="emergencyCountryCode"
                        bindValue="code" [placeholder]="content?.['b2b.managetraveler.emerphonecountrycode']"
                        (contextmenu)="_CommonService.disableRightClick($event)"
                        (paste)="_CommonService.onPasteBlocked($event)" (keypress)="emergengyPhoneValidation($event)"
                        data-dd-privacy="mask">
                        <ng-template ng-optgroup-tmp let-item="item"> {{ item.group }} </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                            <span class="ng-option-label">
                                <ng-container *ngIf="!!item?.newFlag?.src">
                                    <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}"
                                        class="flag-img" [height]="item.height" [width]="item.width" />
                                </ng-container>
                                {{ item.code }} ({{ item?.countryName }})
                            </span>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="ng-value-label"> {{ item.code }} </span>
                        </ng-template>
                        <ng-template ng-notfound-tmp>
                            <div class="no-items-found">
                                <img src="assets/images/not-found.png" alt="No items found" class="no-items-image" />
                                <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
                            </div>
                        </ng-template>
                    </ng-select>
                    <mat-error class="px-4"
                        *ngIf="EmergencyContactForm?.get('emergencyCountryCode')?.hasError('required') && EmergencyContactForm?.get('emergencyCountryCode')?.touched">Code
                        is Required.</mat-error>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.emerphoneno']}} </mat-label>
                        <input matInput formControlName="emergencyPhoneNumber"
                            (keypress)="_CommonService.allowedNumberOnly($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)"
                            data-dd-privacy="mask">
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>phone_android</mat-icon>
                        <mat-error
                            *ngIf="EmergencyContactForm.get('emergencyPhoneNumber')?.hasError('required') && EmergencyContactForm.get('emergencyPhoneNumber')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.emerphonenoreq']}}</mat-error>

                        <mat-error *ngIf=" EmergencyContactForm.get('emergencyPhoneNumber')?.hasError('minlength') ">{{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}}</mat-error>
                        <mat-error *ngIf=" EmergencyContactForm.get('emergencyPhoneNumber')?.hasError('maxlength') ">{{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}}</mat-error>
                        <!-- <mat-error *ngIf=" EmergencyContactForm.get('emergencyPhoneNumber')?.hasError('pattern') ">Emergency Phone number must be 10 digit. </mat-error> -->
                    </mat-form-field>
                </div>
            </div>
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <ng-select [items]="newCustomCountries" groupBy="group"
                        [searchFn]="_CommonService.customCountrySearchFn" formControlName="altCountryCode"
                        bindValue="code" [placeholder]="content?.['b2b.managetraveler.altphonecountrycode']"
                        (contextmenu)="_CommonService.disableRightClick($event)"
                        (paste)="_CommonService.onPasteBlocked($event)" (keypress)="emergengyPhoneValidation($event)"
                        data-dd-privacy="mask">
                        <ng-template ng-optgroup-tmp let-item="item"> {{ item.group }} </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                            <span class="ng-option-label">
                                <ng-container *ngIf="!!item?.newFlag?.src">
                                    <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}"
                                        class="flag-img" [height]="item.height" [width]="item.width" />
                                </ng-container>
                                {{ item.code }} ({{ item?.countryName }})
                            </span>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="ng-value-label"> {{ item.code }} </span>
                        </ng-template>
                        <ng-template ng-notfound-tmp>
                            <div class="no-items-found">
                                <img src="assets/images/not-found.png" alt="No items found" class="no-items-image" />
                                <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
                            </div>
                        </ng-template>
                    </ng-select>
                    <mat-error class="px-4"
                        *ngIf="EmergencyContactForm?.get('altCountryCode')?.hasError('required') && EmergencyContactForm.get('altCountryCode')?.touched">Code
                        is required.</mat-error>
                </div>

                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.altemerphoneno']}} </mat-label>
                        <input matInput formControlName="altEmergencyPhoneNumber"
                            (keypress)="_CommonService.allowedNumberOnly($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)"
                            data-dd-privacy="mask">
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>phone_android</mat-icon>
                        <mat-error
                            *ngIf="EmergencyContactForm.get('altEmergencyPhoneNumber')?.hasError('required') && EmergencyContactForm.get('altEmergencyPhoneNumber')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.altemerphonenoreq']}}</mat-error>
                        <mat-error *ngIf=" EmergencyContactForm.get('altEmergencyPhoneNumber')?.hasError('minlength') ">{{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}}</mat-error>
                        <mat-error *ngIf=" EmergencyContactForm.get('altEmergencyPhoneNumber')?.hasError('maxlength') ">{{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}}</mat-error>
                        <!-- <mat-error *ngIf=" EmergencyContactForm.get('altEmergencyPhoneNumber')?.hasError('pattern') ">Alternative Emergency Phone number must be 10 digit. </mat-error> -->
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="inner-action" *ngIf="!Loader.isEditableClicked">
            <button mat-button class="button--secondary-small" type="button" [class.disabled]="Loader.isEditableClicked || (!hasEmployeeData && !checkEmergencyContactValues())"
                [disabled]="Loader.isEditableClicked || (!hasEmployeeData && !checkEmergencyContactValues())"
                (click)="Cancel()">{{content?.['b2b.managetraveler.cancel']}}</button>
            <button mat-button class="button--primary-small"
                [class.disabled]="Loader.isEditableClicked || EmergencyContactForm.invalid || noDataPersonalInfo || (!hasEmployeeData && !checkEmergencyContactValues())"
                [disabled]="Loader.isEditableClicked || EmergencyContactForm.invalid || noDataPersonalInfo || (!hasEmployeeData && !checkEmergencyContactValues())"
                (click)="saveEmergencyContact()">
                <mat-spinner class="button" *ngIf="Loader.isSpinner"></mat-spinner>
                {{content?.['b2b.managetraveler.save']}}</button>
        </div>
    </div>
</form>